import axios from 'axios';
import store from '../pathify/store'

export default {
    login (body) {
        return axios.post(process.env.API_BACKEND + '/v1/login_by_username', body)
    },
    getDataUser () {
        return axios.get(process.env.API_BACKEND + '/v1/getUserData', store.state.header)
    },
    getDataDashboard () {
        return axios.get(process.env.API_BACKEND + '/v1/getDataForDashboard', store.state.header)
    },

    //List Report
    getlistAED (params) {
        return axios.get(process.env.API_BACKEND_go + '/v1/aed-pagination' + params, store.state.header)
    },
    getlistMaintenanceAED (params) {
        return axios.get(process.env.API_BACKEND_go + '/v1/maintenance-aed' + params, store.state.header)
    },
    getlistUser () {
        return axios.get(process.env.API_BACKEND + '/v1/getAllUser', store.state.header)
    },
    getlistAdmin () {
        return axios.get(process.env.API_BACKEND + '/v1/getListGenerateAdmin', store.state.header)
    },
    getlisthistoryAED (params) {
        return axios.get(process.env.API_BACKEND_go + '/v1/user/history-use-aed-by-aed-id' + params, store.state.header)
    },
    getliststHistoryUse (params) {
        return axios.get(process.env.API_BACKEND_go + '/v1/super-admin/history-use-aed' + params, store.state.header)
    },
    getlistissue () {
        return axios.get(process.env.API_BACKEND + '/v1/getAllIssueAED', store.state.header)
    },
    getListGenerateQrCode () {
        return axios.get(process.env.API_BACKEND + '/v1/getListGenerateQrCode', store.state.header)
    },
    getListGenerateQrCodeByGenerateID (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getListGenerateQrCodeByGenerateID', body, store.state.header)
    },
    getAskForHelpData () {
        return axios.get(process.env.API_BACKEND + '/v1/getAskForHelpData', store.state.header)
    },

    getDataAED (aed_id) {
        return axios.get(process.env.API_BACKEND + '/v1/getAedDetailByAEDID/' + aed_id, store.state.header)
    },
    getCompanyMaintenance () {
        return axios.get(process.env.API_BACKEND + '/v1/getCompanyMaintenance', store.state.header)
    },
    getCompanyOwner () {
        return axios.get(process.env.API_BACKEND + '/v1/getCompanyOwner', store.state.header)
    },

    changeStatusHistory (body) {
        return axios.put(process.env.API_BACKEND_go + '/v1/status-history-use-aed' , body, store.state.header)
    },

    getAllCompany () {
        return axios.get(process.env.API_BACKEND + '/v1/getAllCompany', store.state.header)
    },
    getAllIssueByAEDId (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getAllIssueByAEDId', body, store.state.header)
    },
    getAEDDetailByQrCodeID (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getAEDDetailByQrCodeID', body)
    },
    getAskForHelpDataByRequestID (request_id) {
        return axios.get(process.env.API_BACKEND + '/v1/getAskForHelpDataByRequestID/' + request_id, store.state.header)
    },

    createAdminByInfo (body) {
        return axios.post(process.env.API_BACKEND + '/v1/createAdminByInfo', body, store.state.header)
    },
    createAdminBySystemGenerate (body) {
        return axios.post(process.env.API_BACKEND + '/v1/createAdminBySystemGenerate', body, store.state.header)
    },

    genQrCodeByNumber (body) {
        return axios.post(process.env.API_BACKEND + '/v1/genQrCodeByNumber', body, store.state.header)
    },
    genQrCodeByDetail (body) {
        return axios.post(process.env.API_BACKEND + '/v1/genQrCodeByDetail', body, store.state.header)
    },
    deleteQrCode (body) {
        return axios.post(process.env.API_BACKEND + '/v1/deleteQrCode', body, store.state.header)
    },

    changeRoleUser (body) {
        return axios.post(process.env.API_BACKEND + '/v1/changeRoleUser', body, store.state.header)
    },

    createCompany (body) {
        return axios.post(process.env.API_BACKEND + '/v1/createCompany', body, store.state.header)
    },
    editCompany (body) {
        return axios.post(process.env.API_BACKEND + '/v1/editCompany', body, store.state.header)
    },

    updateUserData (body) {
        return axios.post(process.env.API_BACKEND + '/v1/updateUserData', body, store.state.header)
    },

    deleteAED (body) {
        return axios.post(process.env.API_BACKEND + '/v1/deleteAED', body, store.state.header)
    },

    getDetailUserByGenerateId (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getDetailUserByGenerateId', body, store.state.header)
    },
    getUserDetailByUserId (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getUserDetailByUserId', body, store.state.header)
    },

    decodePWDByList (body) {
        return axios.post(process.env.API_BACKEND + '/v1/decodePWDByList', body, store.state.header)
    },

    getIssueDetailByIssueID (body) {
        return axios.post(process.env.API_BACKEND + '/v1/getIssueDetailByIssueID', body, store.state.header)
    },
    confirmIssueAED (body) {
        return axios.post(process.env.API_BACKEND + '/v1/confirmIssueAED', body, store.state.header)
    },
    closeIssueAED (body) {
        return axios.post(process.env.API_BACKEND + '/v2/closeIssueAED', body, store.state.header)
    },
    confirmCloseIssueAED (body) {
        return axios.post(process.env.API_BACKEND + '/v2/confirmCloseIssueAED', body, store.state.header)
    },
}


// WEBPACK FOOTER //
// ./src/services/apiGlobal.js